import { ReceiptSelectionEmailToggleController as controller } from './receipt-selection-email-toggle.controller'
import template from './receipt-selection-email-toggle.html'

export const ReceiptSelectionEmailToggleComponent = {
  template,
  controller,
}
